import {
  IonAlert,
  IonButton,
  IonCheckbox,
  IonIcon,
  IonItem,
  IonList,
  IonRadio,
  IonRadioGroup,
  IonTextarea,
} from '@ionic/react';
import { chevronBackOutline } from 'ionicons/icons';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getConfig } from '../../appConfig';
import { FlexSpacer, NormalText, SmallText, Spacer, StrongText, Subtitle, Title } from '../../components/common';
import Incrementer from '../../components/incrementer';
import Layout from '../../components/layout';
import Modal from '../../components/modal';
import { PillGroup } from '../../components/pill';
import Basket from '../../lib/basket';
import { withTranslation } from '../../lib/translate';
import {
  capitalize,
  deepCopy,
  forwardTo,
  getLocale,
  isDefined,
  isEmptyObject,
  isWebConfig,
  makeKey,
  openExternalLink,
  sendToAnalytics,
  formatBasketItemForAnalytics,
  getAnalyticsCurrency,
  roundAnalyticsMoney,
} from '../../lib/utils';
import { storeItemWeb } from '../../store/actions';
import './index.css';
import { ReactComponent as DiscountIcon } from '../../assets/images/discount.svg';
import { alertCircle } from 'ionicons/icons';
import { ReactComponent as EditIcon } from '../../assets/images/edit-icon.svg';
import Slider, { Slide } from '../../components/slider';

const {
  formatPrice,
  _calculateItemPrice,
  calculateItemPrice,
  validateItem,
  addToBasket,
  getProductName,
  getProductDescription,
  isProductEnabled,
  isProductJustEnabled,
  isChoicesGroupValid,
  setAllergen,
  getProductModifierName
} = Basket;


const MODIFIERS_DISPLAY_CONFIG = {
  "mobile": {
    "mandatoryModifiers": "list",
    "optionalModifiers": "carousel",
  },
  "desktop": {
    "mandatoryModifiers": "list",
    "optionalModifiers": "list",
  },
};

const BUNDLE_RADIO_VALUE_PREFIX = 'bundle:';
const bundleRadioValue = (bundleIndex) => BUNDLE_RADIO_VALUE_PREFIX + bundleIndex;
const isBundleRadioValue = (value) =>
  typeof value === 'string' && value.indexOf(BUNDLE_RADIO_VALUE_PREFIX) === 0;

const getModifiersDisplayType = (mustSelectAnItem) => {
  const config = getConfig().general.modifiersDisplayConfig ?? MODIFIERS_DISPLAY_CONFIG
  const platform = isWebConfig() ? 'desktop' : 'mobile';
  const groupType = mustSelectAnItem ? 'mandatoryModifiers' : 'optionalModifiers';
  return config[platform]?.[groupType] || 'list';
};

class itemDetailsContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      quantity: 1,
      price: 0,
      selectedChoices: [],
      validationErrors: [],
      showValidationAlert: false,
      allergensCodes: [],
      specialInstructionsModalOpen: false,
      instructions: '',
      modalInstructions: '',
      selectedSubChoices: [],
    };
  }

  componentDidMount() {
    const { profile, allergens, item } = this.props;
    let quantity = this.state.quantity;
    let selectedChoices = [];
    let validationErrors = [];
    let selectedSubChoices = [];

    if (item.menuDealGroups && item.menuDealGroups.length > 0) {
      // the POS can flag a choice as on by default (Square's on_by_default), so tick
      // those the same way a tap would, capped by what the group actually allows
      selectedChoices = item.menuDealGroups.map((menuDealGroup) => {
        const preselected = (menuDealGroup.items || [])
          .filter(
            (choice) =>
              choice.preselected &&
              choice.sku !== undefined &&
              (getConfig().flags.showSnoozedProducts
                ? isProductJustEnabled(choice)
                : isProductEnabled(choice)),
          )
          .map((choice) => {
            const selectedChoice = deepCopy(choice);
            selectedChoice.quantity = 1;
            return selectedChoice;
          });
        const max = menuDealGroup.multiSelectionPermitted ? menuDealGroup.max : 1;
        return isDefined(max) && max > 0 ? preselected.slice(0, max) : preselected;
      });
      validationErrors = Array(item.menuDealGroups.length).fill(null);
      if (item.menuDealGroups.some((menuDealGroup) => menuDealGroup.bundleModifiers)) {
        selectedSubChoices = item.menuDealGroups.map((menuDealGroup) =>
          (menuDealGroup.items || []).map((choice, choiceIndex) =>
            Basket.getBundleModifierGroups(menuDealGroup, choiceIndex).map(() => []),
          ),
        );
      }
    }
    let price = _calculateItemPrice({ item, quantity, selectedChoices });
    let locale = getLocale(profile);
    if (locale === 'fr') {
      locale = 'fr_FR';
    }
    let allergensCodes = item ? (item.itemRichData ? ((item.itemRichData.allergenCodes && item.itemRichData.allergenCodes.length) > 0 ? item.itemRichData.allergenCodes : []) : []) : [];
    let newArr = [];
    allergensCodes.map((allergenCode) => {
      let dataArr = (allergens && allergens.data ? allergens.data : []).find((allergen) => {
        let dataArr2 = null;
        if (allergen.code === allergenCode) {
          dataArr2 = allergen.translations.find((data) => {
            if (data.locale === locale) {
              newArr.push(data.text);
              return data;
            }
            return null;
          });
        }
        return dataArr2;
      });
      if (!dataArr) {
        newArr.push(allergenCode);
      }
      return null;
    });
    this.props.handleAlergens(newArr)
    this.setState({ price, selectedChoices, selectedSubChoices, validationErrors, allergensCodes: newArr }, () => {
      const initialValidationErrors = validateItem(this.constructBasketItem());
      this.setState({ validationErrors: initialValidationErrors.errors });
    });
    try {
      sendToAnalytics('view_item', {
        ecommerce: {
          currency: getAnalyticsCurrency(),
          value: roundAnalyticsMoney(calculateItemPrice({ item, quantity })),
          items: [formatBasketItemForAnalytics({ item, quantity: 1 })],
        },
      });
    } catch (e) { console.log('Error_sending_view_item_analytics', e); }
  }

  onIncrementerUpdate = (newQuantity) => {
    this.setState({
      quantity: newQuantity,
      price: _calculateItemPrice({
        item: this.props.item,
        quantity: newQuantity,
        selectedChoices: this.state.selectedChoices,
        selectedSubChoices: this.state.selectedSubChoices,
      }),
    });
  };

  updateSelectedChoices = (
    groupIndex,
    choiceIndex,
    multiSelectionPermitted,
    selected = true,
    quantity = 0,
  ) => {
    // const item = this.props.location.state
    const { item } = this.props;
    const { selectedChoices } = this.state;
    const allGroups = item.menuDealGroups ? item.menuDealGroups : [];
    const selectedGroup = allGroups[groupIndex];
    if (selectedGroup) {
      const selectedChoice = selectedGroup.items[choiceIndex]
        ? deepCopy(selectedGroup.items[choiceIndex])
        : {};
      let updatedSelectedChoices = deepCopy(selectedChoices);
      let selectedChoiceIndex = -1;
      const existingChoice = updatedSelectedChoices[groupIndex].find((i, index) => {
        if (selectedChoice && i.sku === selectedChoice.sku) {
          selectedChoiceIndex = index;
          return true;
        }
        return false;
      });
      if (multiSelectionPermitted) {
        //checkbox
        if (selected) {
          selectedChoice.quantity = 1;
          if (existingChoice) {
            existingChoice.quantity = quantity;
            if (
              selectedChoiceIndex !== -1 &&
              updatedSelectedChoices[groupIndex] &&
              updatedSelectedChoices[groupIndex][selectedChoiceIndex]
            ) {
              updatedSelectedChoices[groupIndex][selectedChoiceIndex] = existingChoice;
            }
          } else {
            updatedSelectedChoices[groupIndex].push(selectedChoice);
          }
        } else {
          selectedChoice.quantity = 0;
          updatedSelectedChoices[groupIndex] = updatedSelectedChoices[groupIndex].filter(
            (i) => i.sku !== selectedChoice.sku,
          );
        }
      } else {
        if (selected) {
          selectedChoice.quantity = quantity;
          updatedSelectedChoices[groupIndex] = [selectedChoice];
        } else {
          selectedChoice.quantity = 0;
          updatedSelectedChoices[groupIndex] = [];
        }
      }

      this.setState(
        {
          selectedChoices: updatedSelectedChoices,
          selectedSubChoices: this.getResetSubChoices(groupIndex, updatedSelectedChoices[groupIndex]),
        },
        () => {
          const { selectedChoices, selectedSubChoices } = this.state;
          const newCalculatedPrice = _calculateItemPrice({
            item,
            quantity: this.state.quantity,
            selectedChoices,
            selectedSubChoices,
          });
          this.setState({ price: newCalculatedPrice }, () => {
            if (this.props.priceUpdated) {
              this.props.priceUpdated(newCalculatedPrice);
            }
            const validationErrors = validateItem(this.constructBasketItem());
            this.setState({ validationErrors: validationErrors.errors });
          });
        },
      );
    }
  };
  instructionsChange = (event) => this.setState({ modalInstructions: event.target.value.replace(/[\p{Emoji_Presentation}\p{Extended_Pictographic}\p{So}]/gu, '') });

  handleInputChange = (groupIndex, choiceIndex, multiSelectionPermitted, event) => {
    const item = this.props.item;
    const allGroups = item.menuDealGroups ? item.menuDealGroups : [];
    const selectedGroup = allGroups[groupIndex];
    if (selectedGroup) {
      const selectedChoice = selectedGroup.items[choiceIndex];
      this.updateSelectedChoices(
        groupIndex,
        choiceIndex,
        multiSelectionPermitted,
        multiSelectionPermitted ? event.target.checked : !!selectedChoice,
        selectedChoice ? 1 : 0,
      );
    }
  };

  onIncrementerChoiceUpdate = (newQuantity, data) => {
    const { item } = this.props;
    const allGroups = item.menuDealGroups ? item.menuDealGroups : [];
    const selectedGroup = allGroups[data.groupIndex];
    if (selectedGroup) {
      this.updateSelectedChoices(
        data.groupIndex,
        data.choiceIndex,
        data.multiSelectionPermitted,
        newQuantity > 0,
        newQuantity,
      );
    }
  };

  getResetSubChoices = (groupIndex, selectedChoiceGroup) => {
    const { item } = this.props;
    const { selectedSubChoices } = this.state;
    const menuDealGroup = (item.menuDealGroups || [])[groupIndex];
    if (!menuDealGroup || !menuDealGroup.bundleModifiers || !selectedSubChoices[groupIndex]) {
      return selectedSubChoices;
    }
    const updatedSelectedSubChoices = deepCopy(selectedSubChoices);
    updatedSelectedSubChoices[groupIndex] = (updatedSelectedSubChoices[groupIndex] || []).map(
      (subGroups, choiceIndex) => {
        const choice = (menuDealGroup.items || [])[choiceIndex];
        const stillSelected = !!(selectedChoiceGroup || []).find(
          (i) => choice && i.sku === choice.sku,
        );
        return stillSelected ? subGroups : (subGroups || []).map(() => []);
      },
    );
    return updatedSelectedSubChoices;
  };

  updateSelectedSubChoices = (
    groupIndex,
    choiceIndex,
    subGroupIndex,
    bundleIndex,
    multiSelectionPermitted,
    selected = true,
    quantity = 0,
  ) => {
    const { item } = this.props;
    const { selectedSubChoices } = this.state;
    const menuDealGroup = (item.menuDealGroups || [])[groupIndex];
    const subGroup = Basket.getBundleModifierGroups(menuDealGroup, choiceIndex)[subGroupIndex];
    const parentChoice = ((menuDealGroup || {}).items || [])[choiceIndex];
    if (!subGroup || !parentChoice) {
      return;
    }
    const selectedChoice = subGroup.items[bundleIndex]
      ? deepCopy(subGroup.items[bundleIndex])
      : {};
    selectedChoice.parentModifierSku = parentChoice.sku;
    selectedChoice.bundleModifier = true;

    const updatedSelectedSubChoices = deepCopy(selectedSubChoices);
    if (!updatedSelectedSubChoices[groupIndex]) {
      updatedSelectedSubChoices[groupIndex] = [];
    }
    if (!updatedSelectedSubChoices[groupIndex][choiceIndex]) {
      updatedSelectedSubChoices[groupIndex][choiceIndex] = [];
    }
    let subGroupChoices = updatedSelectedSubChoices[groupIndex][choiceIndex][subGroupIndex] || [];

    if (multiSelectionPermitted) {
      if (selected) {
        const existingChoiceIndex = subGroupChoices.findIndex((i) => i.sku === selectedChoice.sku);
        if (existingChoiceIndex !== -1) {
          subGroupChoices[existingChoiceIndex].quantity = quantity;
        } else {
          selectedChoice.quantity = quantity || 1;
          subGroupChoices.push(selectedChoice);
        }
      } else {
        subGroupChoices = subGroupChoices.filter((i) => i.sku !== selectedChoice.sku);
      }
    } else {
      if (selected) {
        selectedChoice.quantity = quantity || 1;
        subGroupChoices = [selectedChoice];
      } else {
        subGroupChoices = [];
      }
    }
    updatedSelectedSubChoices[groupIndex][choiceIndex][subGroupIndex] = subGroupChoices;

    this.setState({ selectedSubChoices: updatedSelectedSubChoices }, () => {
      const newCalculatedPrice = _calculateItemPrice({
        item,
        quantity: this.state.quantity,
        selectedChoices: this.state.selectedChoices,
        selectedSubChoices: this.state.selectedSubChoices,
      });
      this.setState({ price: newCalculatedPrice }, () => {
        if (this.props.priceUpdated) {
          this.props.priceUpdated(newCalculatedPrice);
        }
        const validationErrors = validateItem(this.constructBasketItem());
        this.setState({ validationErrors: validationErrors.errors });
      });
    });
  };

  handleSubInputChange = (
    groupIndex,
    choiceIndex,
    subGroupIndex,
    bundleIndex,
    multiSelectionPermitted,
    event,
  ) => {
    event.stopPropagation();
    const isChecked = event.target.checked;
    this.updateSelectedSubChoices(
      groupIndex,
      choiceIndex,
      subGroupIndex,
      bundleIndex,
      multiSelectionPermitted,
      isChecked,
      isChecked ? 1 : 0,
    );
  };

  handleSubRadioGroupChange = (groupIndex, choiceIndex, subGroupIndex, event) => {
    event.stopPropagation();
    if (event.currentTarget && event.target !== event.currentTarget) {
      return;
    }
    const bundleIndex = isBundleRadioValue(event.target.value)
      ? parseInt(event.target.value.slice(BUNDLE_RADIO_VALUE_PREFIX.length), 10)
      : -1;
    const menuDealGroup = (this.props.item.menuDealGroups || [])[groupIndex];
    const subGroup = Basket.getBundleModifierGroups(menuDealGroup, choiceIndex)[subGroupIndex];
    const selectedChoice = subGroup ? (subGroup.items || [])[bundleIndex] : null;
    this.updateSelectedSubChoices(
      groupIndex,
      choiceIndex,
      subGroupIndex,
      bundleIndex,
      false,
      !!selectedChoice,
      selectedChoice ? 1 : 0,
    );
  };

  onIncrementerSubChoiceUpdate = (newQuantity, data) => {
    this.updateSelectedSubChoices(
      data.groupIndex,
      data.choiceIndex,
      data.subGroupIndex,
      data.bundleIndex,
      data.multiSelectionPermitted,
      newQuantity > 0,
      newQuantity,
    );
  };

  drawSubModifiersLabel = (subGroup) => {
    const { profile } = this.props;
    const name = getProductModifierName(subGroup, profile).replace(/(<([^>]+)>)/gi, '');
    return (
      <div className="bundle-modifiers-label">
        {name ? <Title className="block">{name}</Title> : null}
        <NormalText className="block field-error">
          {isWebConfig() && <IonIcon icon={alertCircle} />}
          {this.getMinMaxLabel(subGroup)}
        </NormalText>
      </div>
    );
  };

  getAllergensData = (item) => {
    const { profile, allergens } = this.props;
    const allergensCodes = item?.itemRichData?.allergenCodes || [];
    if (allergensCodes.length === 0) {
      return [];
    }
    const locale = getLocale(profile);
    return allergensCodes.map((allergenCode) => {
      const allergenData = allergens?.data?.find((el) => el.code === allergenCode);
      const translation = allergenData?.translations?.find((el) => el.locale === locale);
      return translation ? translation.text : allergenCode;
    });
  };

  drawSubModifiers = (subGroup, subGroupIndex, groupIndex, choiceIndex) => {
    const { profile, __ } = this.props;
    const { selectedSubChoices } = this.state;
    const { items, multiMax } = subGroup;
    const max = Math.max(0, parseInt(subGroup.max ?? subGroup.maximumSelection) || 0);
    const multiSelectionPermitted = Basket.isBundleModifierGroupMultiSelection(subGroup);
    const itemWithImages = getConfig().flags.hasModifierUpsellSlider;
    const selectedSubGroup =
      ((selectedSubChoices[groupIndex] || [])[choiceIndex] || [])[subGroupIndex] || [];
    const groupQuantity = selectedSubGroup.reduce((sum, i) => sum + (i.quantity || 0), 0);

    const allSubChoices = (items || []).map((subItem, bundleIndex) => {
      const { sku, productPrice } = subItem;
      if (
        sku === undefined ||
        (getConfig().flags.showSnoozedProducts
          ? !isProductJustEnabled(subItem)
          : !isProductEnabled(subItem))
      ) {
        return (
          <span
            key={makeKey('bundle', groupIndex, choiceIndex, subGroupIndex, bundleIndex, 'disabled')}
          />
        );
      }
      const selectedChoice = selectedSubGroup.find((i) => i.sku === sku);
      const isChecked = !!selectedChoice;
      const quantity = selectedChoice ? selectedChoice.quantity : 0;
      const shouldBeDisabled =
        multiSelectionPermitted && max > 0 && groupQuantity >= max && !isChecked;
      const allergensData = itemWithImages ? this.getAllergensData(subItem) : [];
      const incrementer =
        isChecked && max > 1 && multiMax > 1 ? (
          <div className="incrementer-box">
            <Incrementer
              {...(isWebConfig() && { allowInput: true })}
              allowNegative={false}
              data={{
                groupIndex,
                choiceIndex,
                subGroupIndex,
                bundleIndex,
                multiSelectionPermitted,
              }}
              disabled={shouldBeDisabled}
              maxLimit={Math.min(multiMax, (quantity || 0) + max - groupQuantity)}
              onUpdate={this.onIncrementerSubChoiceUpdate}
              quantity={quantity || 0}
            />
          </div>
        ) : null;
      // desktop hides the checkbox/radio label, so the content is rendered as a sibling instead
      const label = isWebConfig() ? null : itemWithImages ? (
        <div className="item-details-data item-details-data-with-image">
          <img
            src={
              subItem?.itemRichData?.rawImageUrl
                ? subItem.itemRichData.rawImageUrl.replace(/http:\/\//g, 'https://')
                : Basket.getRestaurant()?.menu_item_placeholder_image ??
                this.props.clientProfile.logo_image
            }
          />
          <div>
            <StrongText className="item-details-data-name">
              {__(getProductName(subItem, profile))}
            </StrongText>
            {allergensData.length > 0 ? (
              <div className="item-allergens">
                <Spacer size={0} />
                <SmallText className="block primary-color">
                  {allergensData.map((el) => capitalize(el)).join(', ')}
                </SmallText>
              </div>
            ) : null}
          </div>
          {formatPrice(productPrice) ? <NormalText>{formatPrice(productPrice)}</NormalText> : null}
        </div>
      ) : (
        <div className="item-details-data">
          <div>
            <StrongText>{__(getProductName(subItem, profile))}</StrongText>
          </div>
          {formatPrice(productPrice) ? <StrongText>{formatPrice(productPrice)}</StrongText> : null}
        </div>
      );

      return (
        <div
          className={
            'sub-item bundle-modifiers ' +
            (itemWithImages ? 'sub-item-slider ' : '') +
            (!Basket.isProductUnsnoozed(subItem) ? 'disabled-element' : '')
          }
          key={makeKey('bundle', groupIndex, choiceIndex, subGroupIndex, bundleIndex, sku)}
        >
          <IonItem lines="none">
            <div>
              {Basket.isProductUnsnoozed(subItem) ? (
                <>
                  {multiSelectionPermitted ? (
                    <IonCheckbox
                      labelPlacement="end"
                      disabled={shouldBeDisabled}
                      className="details"
                      color="primary"
                      slot="start"
                      checked={isChecked}
                      onIonChange={(event) => {
                        this.handleSubInputChange(
                          groupIndex,
                          choiceIndex,
                          subGroupIndex,
                          bundleIndex,
                          multiSelectionPermitted,
                          event,
                        );
                      }}
                    >
                      {label}
                    </IonCheckbox>
                  ) : (
                    <IonRadio
                      labelPlacement="end"
                      slot="start"
                      className={'details' + (isChecked ? ' primary-radio' : '')}
                      color="primary"
                      value={bundleRadioValue(bundleIndex)}
                      checked={isChecked}
                    >
                      {label}
                    </IonRadio>
                  )}
                </>
              ) : (
                <div className="checkbox-placeholder"></div>
              )}
              {isWebConfig() ? (
                <div className="sub-item-content">
                  {itemWithImages ? (
                    <div className="modifier-image">
                      <img
                        src={
                          subItem?.itemRichData?.squareImageUrl
                            ? subItem.itemRichData.squareImageUrl.replace(/http:\/\//g, 'https://')
                            : Basket.getRestaurant()?.menu_item_placeholder_image ??
                              this.props.clientProfile.logo_image
                        }
                      />
                    </div>
                  ) : null}
                  <div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', gap: '15px' }}>
                      <StrongText>{__(getProductName(subItem, profile))}</StrongText>
                      {formatPrice(productPrice) ? (
                        <StrongText>{formatPrice(productPrice)}</StrongText>
                      ) : null}
                    </div>
                    {allergensData.length > 0 ? (
                      <SmallText className="primary-color">
                        {allergensData.map((el) => capitalize(el)).join(', ')}
                      </SmallText>
                    ) : null}
                    <div className="price-increment-content">{incrementer || <div></div>}</div>
                  </div>
                </div>
              ) : (
                <div className="price-increment-content">{incrementer}</div>
              )}
            </div>
          </IonItem>
        </div>
      );
    });

    if (multiSelectionPermitted) {
      return allSubChoices;
    }
    return (
      <IonRadioGroup
        className="bundle-modifiers-radio-group"
        allowEmptySelection={true}
        value={
          selectedSubGroup.length > 0
            ? bundleRadioValue((items || []).findIndex((i) => i.sku === selectedSubGroup[0].sku))
            : -1
        }
        onIonChange={(event) =>
          this.handleSubRadioGroupChange(groupIndex, choiceIndex, subGroupIndex, event)
        }
      >
        {allSubChoices}
      </IonRadioGroup>
    );
  };

  drawSubModifiersForChoice = (menuGroupItem, groupIndex, choiceIndex) => {
    const subGroups = Basket.getBundleModifierGroups(menuGroupItem, choiceIndex);
    if (subGroups.length === 0) {
      return null;
    }
    const { selectedSubChoices } = this.state;
    const selectedChoiceSubChoices = (selectedSubChoices[groupIndex] || [])[choiceIndex] || [];
    return (
      <div className="bundle-modifiers-wrapper">
        {subGroups.map((subGroup, subGroupIndex) => (
          <div
            className={
              'bundle-modifiers-group' +
              (Basket.getBundleModifierGroupError(
                subGroup,
                selectedChoiceSubChoices[subGroupIndex] || [],
              )
                ? ' group-required'
                : '')
            }
            key={makeKey('bundle-group', groupIndex, choiceIndex, subGroupIndex)}
          >
            {this.drawSubModifiersLabel(subGroup)}
            {this.drawSubModifiers(subGroup, subGroupIndex, groupIndex, choiceIndex)}
          </div>
        ))}
      </div>
    );
  };

  getSelectedChoiceIndex = (groupIndex) => {
    const { item } = this.props;
    const { selectedChoices } = this.state;
    const choices = ((item.menuDealGroups || [])[groupIndex] || {}).items || [];
    const selectedChoice = (selectedChoices[groupIndex] || [])[0];
    return selectedChoice ? choices.findIndex((i) => i.sku === selectedChoice.sku) : -1;
  };

  handleRadioGroupChange = (groupIndex, multiSelectionPermitted, event) => {
    if (event.currentTarget && event.target !== event.currentTarget) {
      return;
    }
    if (isBundleRadioValue(event.target.value)) {
      event.target.value = this.getSelectedChoiceIndex(groupIndex);
      return;
    }
    this.handleInputChange(groupIndex, event.target.value, multiSelectionPermitted, event);
  };

  attachSubModifiers = (renderedChoices, menuGroupItem, groupIndex, choices) => {
    if (!menuGroupItem.bundleModifiers) {
      return renderedChoices;
    }
    const { selectedChoices } = this.state;
    return renderedChoices.map((renderedChoice, choiceIndex) => {
      if (Basket.getBundleModifierGroups(menuGroupItem, choiceIndex).length === 0) {
        return renderedChoice;
      }
      const choice = choices[choiceIndex];
      const isChecked = !!(selectedChoices[groupIndex] || []).find(
        (i) => choice && i.sku === choice.sku,
      );
      return (
        <div
          className="sub-item-with-bundle-modifiers"
          key={makeKey('bundle-wrapper', groupIndex, choiceIndex)}
        >
          {renderedChoice}
          {isChecked ? this.drawSubModifiersForChoice(menuGroupItem, groupIndex, choiceIndex) : null}
        </div>
      );
    });
  };

  drawGroupSubModifiers = (menuGroupItem, groupIndex, choices) => {
    if (!menuGroupItem.bundleModifiers) {
      return null;
    }
    const { selectedChoices } = this.state;
    const { profile, __ } = this.props;
    const blocks = choices
      .map((choice, choiceIndex) => {
        const isChecked = !!(selectedChoices[groupIndex] || []).find((i) => i.sku === choice.sku);
        const subModifiers = isChecked
          ? this.drawSubModifiersForChoice(menuGroupItem, groupIndex, choiceIndex)
          : null;
        if (!subModifiers) {
          return null;
        }
        return (
          <div
            className="bundle-modifiers-for-choice"
            key={makeKey('bundle-choice', groupIndex, choiceIndex)}
          >
            {/* <StrongText className="block bundle-modifiers-parent-name">
              {__(getProductName(choice, profile))}
            </StrongText> */}
            {subModifiers}
          </div>
        );
      })
      .filter(Boolean);
    return blocks.length > 0 ? blocks : null;
  };

  drawGroupChoices = (menuGroupItem, multiSelectionPermitted, groupIndex) => {
    const { items, max, multiMax } = menuGroupItem;
    const choices = items || [];
    const { selectedChoices } = this.state;
    const { profile, __ } = this.props;
    const allChoices = choices.map((item, choiceIndex) => {
      const { sku, productPrice } = item;
      const isChecked = !!(selectedChoices[groupIndex] || []).find((i) => {
        return i.sku === sku;
      });
      if (
        item.sku === undefined ||
        (getConfig().flags.showSnoozedProducts
          ? !isProductJustEnabled(item)
          : !isProductEnabled(item))
      ) {
        return <span key={item.sku + '_disabled'} />;
      }
      const groupQuantity =
        selectedChoices[groupIndex] && selectedChoices[groupIndex].length > 0
          ? selectedChoices[groupIndex].reduce((sum, i) => sum + i.quantity || 0, 0)
          : 0;
      let quantity = 0;
      if (selectedChoices[groupIndex]) {
        const _choice = selectedChoices[groupIndex].find((i) => i.sku === sku);
        quantity = _choice ? _choice.quantity : 0;
      }
      let groupQuntity = 0;
      (selectedChoices[groupIndex] || []).forEach((i) => {
        groupQuntity += isDefined(i.quantity) ? i.quantity : 1;
      });
      const shouldBeDisabled =
        isDefined(max) &&
        max > 0 &&
        isDefined(selectedChoices[groupIndex]) &&
        groupQuntity >= max &&
        !isChecked;
      /* eslint-disable */
      const allergensCodes = item?.itemRichData?.allergenCodes || [];
      let locale = getLocale(profile);
      let allergensData = [];
      if (allergensCodes.length > 0) {
        allergensData = allergensCodes.map((allergen) => {
          const allergenData = this.props?.allergens?.data?.find((el) => el.code == allergen);
          const translation = allergenData?.translations && allergenData?.translations?.find((translation) => translation.locale == locale);
          if (translation) {
            return translation.text;
          } else {
            return allergen;
          }
        });
      }
      if (menuGroupItem.hasOwnProperty('multiMax')) {
        /* eslint-enable */
        return (
          <div
            className={`sub-item ${!Basket.isProductUnsnoozed(item) ? 'disabled-element' : ''} `}
            key={makeKey(choiceIndex, sku, groupIndex)}
          >
            <IonItem tabIndex="-1" lines="none">
              <div >
                {Basket.isProductUnsnoozed(item) ? (
                  <>
                    {multiSelectionPermitted ? (
                      <IonCheckbox
                        labelPlacement="end"
                        disabled={shouldBeDisabled}
                        className="details"
                        color='primary'
                        slot="start"
                        checked={isChecked}
                        onIonChange={(event) => {
                          this.handleInputChange(
                            groupIndex,
                            choiceIndex,
                            multiSelectionPermitted,
                            event,
                          );
                        }}
                      >
                        {!isWebConfig() &&
                          <div className='item-details-data'>
                            {getConfig().flags.showModifierImage &&

                              <img
                                src={item?.itemRichData?.rawImageUrl
                                  ? item.itemRichData.rawImageUrl.replace(/http:\/\//g, 'https://')
                                  : Basket.getRestaurant()?.menu_item_placeholder_image ?? this.props.clientProfile.logo_image
                                }
                              />
                            }

                            <div>
                              <StrongText>{__(getProductName(item, profile))}</StrongText>
                              {getProductDescription(item, profile).replace(/(<([^>]+)>)/gi, '') !== '' &&
                                <SmallText>{getProductDescription(item, profile).replace(/(<([^>]+)>)/gi, '')}</SmallText>
                              }
                              {allergensData && allergensData.length > 0 ? (
                                <>
                                  <Spacer size={0} />
                                  <SmallText className='block primary-color'>
                                    {allergensData.map(el => capitalize(el)).join(', ')}
                                  </SmallText>
                                </>

                              ) : null}

                            </div>
                            {formatPrice(productPrice) ? <StrongText>{formatPrice(productPrice)}</StrongText> : null}
                          </div>
                        }

                      </IonCheckbox>

                    ) : (
                      <IonRadio
                        labelPlacement="end"
                        slot="start"
                        className={'details' + (isChecked ? ' primary-radio' : '')}
                        color={'primary'}
                        value={choiceIndex}
                        checked={isChecked}

                      >
                        {!isWebConfig() &&
                          <div className='item-details-data'>
                            {getConfig().flags.showModifierImage &&

                              <img
                                src={item?.itemRichData?.rawImageUrl
                                  ? item.itemRichData.rawImageUrl.replace(/http:\/\//g, 'https://')
                                  : Basket.getRestaurant()?.menu_item_placeholder_image ?? this.props.clientProfile.logo_image
                                }
                              />
                            }
                            <div>
                              <StrongText>{__(getProductName(item, profile))}</StrongText>
                              {getProductDescription(item, profile).replace(/(<([^>]+)>)/gi, '') !== '' &&
                                <SmallText>{getProductDescription(item, profile).replace(/(<([^>]+)>)/gi, '')}</SmallText>
                              }
                              {allergensData && allergensData.length > 0 ? (
                                <>
                                  <Spacer size={0} />
                                  <SmallText className='block primary-color'>
                                    {allergensData.map(el => capitalize(el)).join(', ')}
                                  </SmallText>
                                </>

                              ) : null}

                            </div>
                            {formatPrice(productPrice) ? <StrongText>{formatPrice(productPrice)}</StrongText> : null}
                          </div>
                        }

                      </IonRadio>
                    )}
                  </>
                ) : (
                  <div className="checkbox-placeholder"></div>
                )}
                {isWebConfig()

                  ?
                  <div className='sub-item-content'>
                    {(getConfig().flags.showModifierImage) &&
                      <div className='modifier-image'>
                        {item?.itemRichData?.squareImageUrl ?
                          <img src={item?.itemRichData?.squareImageUrl.replace(/http:\/\//g, 'https://')} />
                          :
                          <img src={Basket.getRestaurant()?.menu_item_placeholder_image ?? this.props.clientProfile.logo_image} />
                        }
                      </div>
                    }
                    <div>
                      <div style={{ display: 'flex', justifyContent: 'space-between', gap: '15px' }}>
                        <StrongText>{__(getProductName(item, profile))}</StrongText>
                        {formatPrice(productPrice) ? <StrongText>{formatPrice(productPrice)}</StrongText> : null}
                      </div>
                      {getProductDescription(item, profile).replace(/(<([^>]+)>)/gi, '') !== '' &&
                        <SmallText>{getProductDescription(item, profile).replace(/(<([^>]+)>)/gi, '')}</SmallText>
                      }

                      {allergensData && allergensData.length > 0 ? (
                        <SmallText className='primary-color'>
                          {allergensData.map(el => capitalize(el)).join(', ')}
                        </SmallText>
                      ) : null}

                      <div className="price-increment-content">

                        {quantity >= 1 && max > 1 && multiMax > 1 ? (
                          <div
                            className={formatPrice(productPrice) ? 'incrementer-box' : 'incrementer-box-top'}
                          >
                            <Incrementer
                              {...(isWebConfig() && { allowInput: true })}
                              allowNegative={false}
                              data={{ groupIndex, choiceIndex, multiSelectionPermitted }}
                              disabled={shouldBeDisabled}
                              maxLimit={Math.min(multiMax, (quantity || 0) + max - groupQuantity)}
                              onUpdate={this.onIncrementerChoiceUpdate}
                              quantity={quantity || 0}
                            />
                          </div>
                        ) : <div></div>}

                      </div>
                    </div>
                  </div> :
                  <div className="price-increment-content">
                    {quantity >= 1 && max > 1 && multiMax > 1 ? (
                      <div
                        className={formatPrice(productPrice) ? 'incrementer-box' : 'incrementer-box-top'}
                      >
                        <Incrementer
                          {...(isWebConfig() && { allowInput: true })}
                          allowNegative={false}
                          data={{ groupIndex, choiceIndex, multiSelectionPermitted }}
                          disabled={shouldBeDisabled}
                          maxLimit={Math.min(multiMax, (quantity || 0) + max - groupQuantity)}
                          onUpdate={this.onIncrementerChoiceUpdate}
                          quantity={quantity || 0}
                        />
                      </div>
                    ) : null}
                  </div>

                }


              </div>
            </IonItem>


          </div>
        );
      } else {
        return (
          <div
            key={makeKey(choiceIndex, sku, groupIndex)}
            className={`sub-item ${!Basket.isProductUnsnoozed(item) ? 'disabled-element' : ''} `}
          >
            <IonItem lines="none" >
              <div>
                {Basket.isProductUnsnoozed(item) ? (
                  <>
                    {multiSelectionPermitted ? (
                      <IonCheckbox
                        labelPlacement="end"
                        disabled={shouldBeDisabled}

                        color="primary"
                        slot="start"
                        checked={isChecked}
                        onIonChange={(event) => {
                          this.handleInputChange(
                            groupIndex,
                            choiceIndex,
                            multiSelectionPermitted,
                            event,
                          );
                        }}
                      >
                        {!isWebConfig() &&
                          <div className='item-details-data'>
                            {getConfig().flags.showModifierImage &&

                              <img
                                src={item?.itemRichData?.rawImageUrl
                                  ? item.itemRichData.rawImageUrl.replace(/http:\/\//g, 'https://')
                                  : Basket.getRestaurant()?.menu_item_placeholder_image ?? this.props.clientProfile.logo_image
                                }
                              />
                            }
                            <div>
                              <StrongText>{__(getProductName(item, profile))}</StrongText>
                              {getProductDescription(item, profile).replace(/(<([^>]+)>)/gi, '') !== '' &&
                                <SmallText>{getProductDescription(item, profile).replace(/(<([^>]+)>)/gi, '')}</SmallText>
                              }
                              {allergensData && allergensData.length > 0 ? (
                                <>
                                  <Spacer size={0} />
                                  <SmallText className='block primary-color'>
                                    {allergensData.map(el => capitalize(el)).join(', ')}
                                  </SmallText>
                                </>

                              ) : null}

                            </div>
                            {formatPrice(productPrice) ? <StrongText>{formatPrice(productPrice)}</StrongText> : null}
                          </div>
                        }

                      </IonCheckbox>

                    ) : (
                      <IonRadio
                        labelPlacement="end"
                        slot="start"
                        className="details-radio"
                        color='primary'
                        value={choiceIndex}
                        checked={isChecked}
                      >

                        {!isWebConfig() &&
                          <div className='item-details-data'>
                            {getConfig().flags.showModifierImage &&

                              <img
                                src={item?.itemRichData?.rawImageUrl
                                  ? item.itemRichData.rawImageUrl.replace(/http:\/\//g, 'https://')
                                  : Basket.getRestaurant()?.menu_item_placeholder_image ?? this.props.clientProfile.logo_image
                                }
                              />
                            }
                            <div>
                              <StrongText>{__(getProductName(item, profile))}</StrongText>
                              {getProductDescription(item, profile).replace(/(<([^>]+)>)/gi, '') !== '' &&
                                <SmallText>{getProductDescription(item, profile).replace(/(<([^>]+)>)/gi, '')}</SmallText>
                              }
                              {allergensData && allergensData.length > 0 ? (
                                <>
                                  <Spacer size={0} />
                                  <SmallText className='block primary-color'>
                                    {allergensData.map(el => capitalize(el)).join(', ')}
                                  </SmallText>
                                </>

                              ) : null}

                            </div>
                            {formatPrice(productPrice) ? <StrongText>{formatPrice(productPrice)}</StrongText> : null}
                          </div>
                        }
                      </IonRadio>

                    )}
                  </>
                ) : (
                  <div className="checkbox-placeholder"></div>
                )}
                {isWebConfig() &&
                  <div className='sub-item-content'>
                    {(getConfig().flags.showModifierImage) &&
                      <div className='modifier-image'>
                        {item?.itemRichData?.squareImageUrl ?
                          <img src={item?.itemRichData?.squareImageUrl.replace(/http:\/\//g, 'https://')} />
                          :
                          <img src={Basket.getRestaurant()?.menu_item_placeholder_image ?? this.props.clientProfile.logo_image} />
                        }
                      </div>
                    }
                    <div>



                      <div style={{ display: 'flex', justifyContent: 'space-between', gap: '15px' }}>
                        <StrongText>{__(getProductName(item, profile))}</StrongText>
                        {formatPrice(productPrice) ? <StrongText>{formatPrice(productPrice)}</StrongText> : null}
                      </div>
                      {getProductDescription(item, profile).replace(/(<([^>]+)>)/gi, '') !== '' &&
                        <SmallText>{getProductDescription(item, profile).replace(/(<([^>]+)>)/gi, '')}</SmallText>
                      }

                      {allergensData && allergensData.length > 0 ? (
                        <SmallText className='primary-color'>
                          {allergensData.map(el => capitalize(el)).join(', ')}
                        </SmallText>
                      ) : null}


                    </div>
                  </div>

                }


              </div>
            </IonItem>


          </div>
        );
      }
    });
    const renderedChoices = this.attachSubModifiers(
      allChoices,
      menuGroupItem,
      groupIndex,
      choices,
    );
    if (multiSelectionPermitted) {
      return <div className="item-details-group-wrapper">{renderedChoices}</div>;
    } else {
      //radio
      return (
        <div className="item-details-group-wrapper">
          <IonRadioGroup
            allowEmptySelection={true}
            value={
              selectedChoices &&
                selectedChoices[groupIndex] &&
                selectedChoices[groupIndex].length > 0
                ? choices.findIndex((i) => i.sku === selectedChoices[groupIndex][0].sku)
                : -1
            }
            onIonChange={(event) =>
              this.handleRadioGroupChange(groupIndex, multiSelectionPermitted, event)
            }
          >
            {renderedChoices}
          </IonRadioGroup>
        </div>
      );
    }
  };

  drawGroupChoicesWithSlider = (menuGroupItem, multiSelectionPermitted, groupIndex) => {
    const { items, max, multiMax, mustSelectAnItem } = menuGroupItem;
    const isCarousel = getModifiersDisplayType(mustSelectAnItem) === 'carousel';
    const choices = items || [];
    const { selectedChoices } = this.state;
    const { profile, __ } = this.props;
    const allChoices = choices.map((item, choiceIndex) => {
      const { sku, productPrice } = item;
      const isChecked = !!(selectedChoices[groupIndex] || []).find((i) => {
        return i.sku === sku;
      });
      if (
        item.sku === undefined ||
        (getConfig().flags.showSnoozedProducts
          ? !isProductJustEnabled(item)
          : !isProductEnabled(item))
      ) {
        return <span key={item.sku + '_disabled'} />;
      }
      const groupQuantity =
        selectedChoices[groupIndex] && selectedChoices[groupIndex].length > 0
          ? selectedChoices[groupIndex].reduce((sum, i) => sum + i.quantity || 0, 0)
          : 0;
      let quantity = 0;
      if (selectedChoices[groupIndex]) {
        const _choice = selectedChoices[groupIndex].find((i) => i.sku === sku);
        quantity = _choice ? _choice.quantity : 0;
      }
      let groupQuntity = 0;
      (selectedChoices[groupIndex] || []).forEach((i) => {
        groupQuntity += isDefined(i.quantity) ? i.quantity : 1;
      });
      const shouldBeDisabled =
        isDefined(max) &&
        max > 0 &&
        isDefined(selectedChoices[groupIndex]) &&
        groupQuntity >= max &&
        !isChecked;
      /* eslint-disable */
      const allergensCodes = item?.itemRichData?.allergenCodes || [];
      let locale = getLocale(profile);
      let allergensData = [];
      if (allergensCodes.length > 0) {
        allergensData = allergensCodes.map((allergen) => {
          const allergenData = this.props?.allergens?.data?.find((el) => el.code == allergen);
          const translation = allergenData?.translations && allergenData?.translations?.find((translation) => translation.locale == locale);
          if (translation) {
            return translation.text;
          } else {
            return allergen;
          }
        });
      }
      if (menuGroupItem.hasOwnProperty('multiMax')) {
        /* eslint-enable */
        return (
          <div
            className={`sub-item sub-item-slider ${!Basket.isProductUnsnoozed(item) ? 'disabled-element' : ''} `}
            key={makeKey(choiceIndex, sku, groupIndex)}
          >
            <IonItem tabIndex="-1" lines="none">
              <div >
                {Basket.isProductUnsnoozed(item) ? (
                  <>
                    {multiSelectionPermitted ? (
                      <IonCheckbox
                        labelPlacement="end"
                        disabled={shouldBeDisabled}
                        className="details"
                        color='primary'
                        slot="start"
                        checked={isChecked}
                        onIonChange={(event) => {
                          this.handleInputChange(
                            groupIndex,
                            choiceIndex,
                            multiSelectionPermitted,
                            event,
                          );
                        }}
                      >
                        {!isWebConfig() &&
                          <div className='item-details-data item-details-data-with-image '>
                            <img
                              src={item?.itemRichData?.rawImageUrl
                                ? item.itemRichData.rawImageUrl.replace(/http:\/\//g, 'https://')
                                : Basket.getRestaurant()?.menu_item_placeholder_image ?? this.props.clientProfile.logo_image
                              }
                            />
                            <div>
                              <StrongText className='item-details-data-name'>{__(getProductName(item, profile))}</StrongText>
                              {allergensData && allergensData.length > 0 ? (
                                <div className='item-allergens'>
                                  <Spacer size={0} />
                                  <SmallText className='block primary-color'>
                                    {allergensData.map(el => capitalize(el)).join(', ')}
                                  </SmallText>
                                </div>

                              ) : null}

                            </div>
                            {formatPrice(productPrice) ? <NormalText>{formatPrice(productPrice)}</NormalText> : null}
                          </div>
                        }

                      </IonCheckbox>

                    ) : (
                      <IonRadio
                        labelPlacement="end"
                        slot="start"
                        className={'details' + (isChecked ? ' primary-radio' : '')}
                        color={'primary'}
                        value={choiceIndex}
                        checked={isChecked}

                      >
                        {!isWebConfig() &&
                          <div className='item-details-data item-details-data-with-image'>
                            <img
                              src={item?.itemRichData?.rawImageUrl
                                ? item.itemRichData.rawImageUrl.replace(/http:\/\//g, 'https://')
                                : Basket.getRestaurant()?.menu_item_placeholder_image ?? this.props.clientProfile.logo_image
                              }
                            />
                            <div>
                              <StrongText className='item-details-data-name'>{__(getProductName(item, profile))}</StrongText>
                              {allergensData && allergensData.length > 0 ? (
                                <div className='item-allergens'>
                                  <Spacer size={0} />
                                  <SmallText className='block primary-color'>
                                    {allergensData.map(el => capitalize(el)).join(', ')}
                                  </SmallText>
                                </div>

                              ) : null}

                            </div>
                            {formatPrice(productPrice) ? <NormalText>{formatPrice(productPrice)}</NormalText> : null}
                          </div>
                        }

                      </IonRadio>
                    )}
                  </>
                ) : (
                  <div className="checkbox-placeholder"></div>
                )}
                {isWebConfig()

                  ?
                  <div className='sub-item-content'>
                    {(getConfig().flags.showModifierImage) &&
                      <div className='modifier-image'>
                        {item?.itemRichData?.squareImageUrl ?
                          <img src={item?.itemRichData?.squareImageUrl.replace(/http:\/\//g, 'https://')} />
                          :
                          <img src={Basket.getRestaurant()?.menu_item_placeholder_image ?? this.props.clientProfile.logo_image} />
                        }
                      </div>
                    }
                    <div>
                      <div style={{ display: 'flex', justifyContent: 'space-between', gap: '15px' }}>
                        <StrongText>{__(getProductName(item, profile))}</StrongText>
                        {formatPrice(productPrice) ? <StrongText>{formatPrice(productPrice)}</StrongText> : null}
                      </div>
                      {/* {getProductDescription(item, profile).replace(/(<([^>]+)>)/gi, '') !== '' &&
                        <SmallText>{getProductDescription(item, profile).replace(/(<([^>]+)>)/gi, '')}</SmallText>
                      } */}

                      {allergensData && allergensData.length > 0 ? (
                        <div className='item-allergens'>

                          <SmallText className='primary-color'>
                            {allergensData.map(el => capitalize(el)).join(', ')}
                          </SmallText>
                        </div>
                      ) : null}

                      <div className="price-increment-content">

                        {quantity >= 1 && max > 1 && multiMax > 1 ? (
                          <div
                            className='incrementer-box'
                          >
                            <Incrementer
                              {...(isWebConfig() && { allowInput: true })}
                              allowNegative={false}
                              data={{ groupIndex, choiceIndex, multiSelectionPermitted }}
                              disabled={shouldBeDisabled}
                              maxLimit={Math.min(multiMax, (quantity || 0) + max - groupQuantity)}
                              onUpdate={this.onIncrementerChoiceUpdate}
                              quantity={quantity || 0}
                            />
                          </div>
                        ) : <div></div>}

                      </div>
                    </div>
                  </div> :
                  <div className="price-increment-content">
                    {(isCarousel ? isChecked : quantity >= 1 && max > 1 && multiMax > 1) ? (
                      <div
                        className='incrementer-box'
                      >
                        <Incrementer
                          {...(isWebConfig() && { allowInput: true })}
                          allowNegative={false}
                          data={{ groupIndex, choiceIndex, multiSelectionPermitted }}
                          disabled={shouldBeDisabled}
                          maxLimit={Math.min(multiMax, (quantity || 0) + max - groupQuantity)}
                          onUpdate={this.onIncrementerChoiceUpdate}
                          quantity={quantity || 0}
                        />
                      </div>
                    ) : null}
                  </div>
                }
              </div>
            </IonItem>
          </div>
        );
      } else {
        return (
          <div
            key={makeKey(choiceIndex, sku, groupIndex)}
            className={`sub-item sub-item-slider ${!Basket.isProductUnsnoozed(item) ? 'disabled-element' : ''} `}
          >
            <IonItem lines="none" >
              <div>
                {Basket.isProductUnsnoozed(item) ? (
                  <>
                    {multiSelectionPermitted ? (
                      <IonCheckbox
                        labelPlacement="end"
                        disabled={shouldBeDisabled}

                        color="primary"
                        slot="start"
                        checked={isChecked}
                        onIonChange={(event) => {
                          this.handleInputChange(
                            groupIndex,
                            choiceIndex,
                            multiSelectionPermitted,
                            event,
                          );
                        }}
                      >
                        {!isWebConfig() &&
                          <div className='item-details-data item-details-data-with-image'>
                            <img
                              src={item?.itemRichData?.rawImageUrl
                                ? item.itemRichData.rawImageUrl.replace(/http:\/\//g, 'https://')
                                : Basket.getRestaurant()?.menu_item_placeholder_image ?? this.props.clientProfile.logo_image
                              }
                            />
                            <div>
                              <StrongText className='item-details-data-name'>{__(getProductName(item, profile))}</StrongText>
                              {allergensData && allergensData.length > 0 ? (
                                <div className='item-allergens'>
                                  <Spacer size={0} />
                                  <SmallText className='block primary-color'>
                                    {allergensData.map(el => capitalize(el)).join(', ')}
                                  </SmallText>
                                </div>

                              ) : null}

                            </div>
                            {formatPrice(productPrice) ? <StrongText>{formatPrice(productPrice)}</StrongText> : null}
                          </div>
                        }

                      </IonCheckbox>

                    ) : (
                      <IonRadio
                        labelPlacement="end"
                        slot="start"
                        className="details-radio"
                        color='primary'
                        value={choiceIndex}
                        checked={isChecked}
                      >

                        {!isWebConfig() &&
                          <div className='item-details-data item-details-data-with-image'>
                            <img
                              src={item?.itemRichData?.rawImageUrl
                                ? item.itemRichData.rawImageUrl.replace(/http:\/\//g, 'https://')
                                : Basket.getRestaurant()?.menu_item_placeholder_image ?? this.props.clientProfile.logo_image
                              }
                            />
                            <div>
                              <StrongText className='item-details-data-name'>{__(getProductName(item, profile))}</StrongText>
                              {allergensData && allergensData.length > 0 ? (
                                <div className='item-allergens'>
                                  <Spacer size={0} />
                                  <SmallText className='block primary-color'>
                                    {allergensData.map(el => capitalize(el)).join(', ')}
                                  </SmallText>
                                </div>

                              ) : null}

                            </div>
                            {formatPrice(productPrice) ? <StrongText>{formatPrice(productPrice)}</StrongText> : null}
                          </div>
                        }
                      </IonRadio>

                    )}
                  </>
                ) : (
                  <div className="checkbox-placeholder"></div>
                )}
                {isWebConfig()
                  ?
                  <div className='sub-item-content'>
                    {(getConfig().flags.showModifierImage) &&
                      <div className='modifier-image'>
                        {item?.itemRichData?.squareImageUrl ?
                          <img src={item?.itemRichData?.squareImageUrl.replace(/http:\/\//g, 'https://')} />
                          :
                          <img src={Basket.getRestaurant()?.menu_item_placeholder_image ?? this.props.clientProfile.logo_image} />
                        }
                      </div>
                    }
                    <div>
                      <div style={{ display: 'flex', justifyContent: 'space-between', gap: '15px' }}>
                        <StrongText>{__(getProductName(item, profile))}</StrongText>
                        {formatPrice(productPrice) ? <StrongText>{formatPrice(productPrice)}</StrongText> : null}
                      </div>
                      {/* {getProductDescription(item, profile).replace(/(<([^>]+)>)/gi, '') !== '' &&
                        <SmallText>{getProductDescription(item, profile).replace(/(<([^>]+)>)/gi, '')}</SmallText>
                      } */}

                      {allergensData && allergensData.length > 0 ? (
                        <div className='item-allergens'>
                          <SmallText className='primary-color'>
                            {allergensData.map(el => capitalize(el)).join(', ')}
                          </SmallText>
                        </div>
                      ) : null}
                    </div>
                  </div> :
                  <div className="price-increment-content">
                    {isCarousel && isChecked ? (
                      <div
                        className='incrementer-box'
                      >
                        <Incrementer
                          allowNegative={false}
                          data={{ groupIndex, choiceIndex, multiSelectionPermitted }}
                          disabled={shouldBeDisabled}
                          maxLimit={1}
                          onUpdate={this.onIncrementerChoiceUpdate}
                          quantity={quantity || 0}
                        />
                      </div>
                    ) : null}
                  </div>
                }
              </div>
            </IonItem>
          </div>
        );
      }
    });
    const groupSubModifiers = isCarousel
      ? this.drawGroupSubModifiers(menuGroupItem, groupIndex, choices)
      : null;
    const renderedChoices = isCarousel
      ? allChoices
      : this.attachSubModifiers(allChoices, menuGroupItem, groupIndex, choices);
    if (isCarousel) {
      const slides = allChoices.map((choice, i) => <Slide key={i}>{choice}</Slide>);
      const slider = (
        <Slider
          settings={{
            slidesPerView: isWebConfig() ? 1.5 : 3.2,
            spaceBetween: 10,
            pagination: {
              el: `.item-details-pagination-${groupIndex}`,
              clickable: true,
            },
          }}
        >
          {slides}
          <div className={`swiper-pagination item-details-pagination-${groupIndex}`}></div>
        </Slider>
      );
      if (multiSelectionPermitted) {
        return (
          <div className="item-details-group-slider item-details-group-wrapper">
            {slider}
            {groupSubModifiers}
          </div>
        );
      } else {
        return (
          <div className="item-details-group-slider item-details-group-wrapper">
            <IonRadioGroup
              allowEmptySelection={true}
              value={
                selectedChoices &&
                  selectedChoices[groupIndex] &&
                  selectedChoices[groupIndex].length > 0
                  ? choices.findIndex((i) => i.sku === selectedChoices[groupIndex][0].sku)
                  : -1
              }
              onIonChange={(event) =>
                this.handleRadioGroupChange(groupIndex, multiSelectionPermitted, event)
              }
            >
              {slider}
            </IonRadioGroup>
            {groupSubModifiers}
          </div>
        );
      }
    } else {
      if (multiSelectionPermitted) {
        return <div className="item-details-group-wrapper">{renderedChoices}</div>;
      } else {
        //radio
        return (
          <div className="item-details-group-wrapper">
            <IonRadioGroup
              allowEmptySelection={true}
              value={
                selectedChoices &&
                  selectedChoices[groupIndex] &&
                  selectedChoices[groupIndex].length > 0
                  ? choices.findIndex((i) => i.sku === selectedChoices[groupIndex][0].sku)
                  : -1
              }
              onIonChange={(event) =>
                this.handleRadioGroupChange(groupIndex, multiSelectionPermitted, event)
              }
            >
              {renderedChoices}
            </IonRadioGroup>
          </div>
        );
      }
    }
  };

  getMinMaxLabel = (group) => {
    const { __ } = this.props;
    let { min, max, maximumSelection, minimumSelection, mustSelectAnItem } = group;
    min = Math.max(0, parseInt(min ?? minimumSelection) || 0);
    max = Math.max(0, parseInt(max ?? maximumSelection) || 0);
    if (mustSelectAnItem && min === 0) {
      min = 1;
    }
    if (min === 0 && max === 0) {
      return __('Optional');
    }
    if (min === 0 && max === 1) {
      return __('Optional - choose 1');
    }
    if (min === 0 && max >= 2) {
      return __('Optional - choose up to {max}', { max });
    }
    if (min === max) {
      return min === 1 ? __('Choose {min} option', { min }) : __('Choose {min} options', { min });
    }
    if (max === 0) {
      return min === 1 ? __('Choose at least {min} option', { min }) : __('Choose at least {min} options', { min });
    }
    return __('Choose between {min} and {max} options', { min, max });
  };

  drawGroupLabel = (menuGroupItem, groupIndex) => {
    const { validationErrors } = this.state;
    const { profile } = this.props;
    const { mustSelectAnItem } = menuGroupItem;
    const hideMinMaxLabel =
      !mustSelectAnItem &&
      getConfig().flags.hasModifierUpsellSlider &&
      getModifiersDisplayType(mustSelectAnItem) === 'carousel';
    const minMaxlabel = this.getMinMaxLabel(menuGroupItem);
    return (
      <>
        <div style={{ width: '100%' }} tabIndex="-1" >
          {(menuGroupItem?.sku !== this.props?.item?.sku) &&
            <Title style={{ fontSize: 'var(--okx-subtitle-font-size)' }}>{getProductModifierName(menuGroupItem, profile).replace(/(<([^>]+)>)/gi, '')}</Title>
          }
          {!hideMinMaxLabel &&
            <NormalText className={validationErrors[groupIndex] ? 'block field-error' : 'block field-error'}>
              {isWebConfig() &&
                <IonIcon icon={alertCircle} />
              }
              {minMaxlabel}
            </NormalText>
          }
        </div>

      </>
    );
  };

  drawMenuDealGroups = (menuGroupItem, index) => {
    // multiSelectionPermitted = true  --> only one item must be selected
    const multiSelectionPermitted = menuGroupItem.multiSelectionPermitted;
    const itemWithImages = getConfig().flags.hasModifierUpsellSlider

    if (isChoicesGroupValid(menuGroupItem)) {
      if (isDefined(multiSelectionPermitted)) {
        return (
          <div className={`item-details-group box-with-shadow ${this.state.validationErrors[index] ? 'group-required' : ''}`} key={index}>
            {this.drawGroupLabel(menuGroupItem, index)}
            {itemWithImages ?
              <>
                {this.drawGroupChoicesWithSlider(menuGroupItem, multiSelectionPermitted, index)}

              </>
              :
              <>
                {this.drawGroupChoices(menuGroupItem, multiSelectionPermitted, index)}
              </>
            }
          </div>
        );
      } else {
        return this.drawGroupLabel(menuGroupItem);
      }
    }
  };

  constructBasketItem = () => {
    const { item } = this.props;
    const { quantity, selectedChoices, instructions, selectedSubChoices } = this.state;
    // const item = item

    return {
      item,
      quantity,
      selectedChoices,
      instructions,
      selectedSubChoices,
    };
  };

  mergeSubChoicesIntoChoices = (basketItem) => {
    const { selectedSubChoices, ...rest } = basketItem;
    if (!selectedSubChoices || selectedSubChoices.length === 0) {
      return rest;
    }
    const selectedChoices = deepCopy(rest.selectedChoices || []);
    selectedSubChoices.forEach((groupSubChoices, groupIndex) => {
      const selectedChoiceGroup = selectedChoices[groupIndex];
      if (!selectedChoiceGroup) {
        return;
      }
      const subChoicesByParent = new Map();
      (groupSubChoices || [])
        .flat(Infinity)
        .filter(Boolean)
        .forEach((subChoice) => {
          const parentSku = subChoice.parentModifierSku;
          if (!subChoicesByParent.has(parentSku)) {
            subChoicesByParent.set(parentSku, []);
          }
          subChoicesByParent.get(parentSku).push(subChoice);
        });
      Array.from(subChoicesByParent.entries()).forEach(([parentSku, subChoices]) => {
        const parentIndex = selectedChoiceGroup.findIndex((el) => el.sku === parentSku);
        if (parentIndex !== -1) {
          selectedChoiceGroup.splice(parentIndex + 1, 0, ...subChoices);
        }
      });
    });
    return { ...rest, selectedChoices };
  };

  addToOrder = () => {
    const newBasketItem = this.constructBasketItem();
    const validationErrors = validateItem(newBasketItem);
    const basketItem = this.mergeSubChoicesIntoChoices(newBasketItem);
    const { item } = this.props;
    if (validationErrors.errorCount > 0) {
      this.setState({ validationErrors: validationErrors.errors }, () => {
        this.setShowValidationAlert(true);
      });
    } else {
      if ((Basket.getOrderType() === 'browse-menu') || (Basket.items.length === 0 && isEmptyObject(this.props.ikentooMenu))) {
        this.props.dispatch(storeItemWeb(basketItem));
        forwardTo('/delivery-options');
      } else {
        addToBasket(basketItem, item?.selectedUpsellRestaurant);
        try {
          sendToAnalytics('add_to_cart', {
            ecommerce: {
              currency: getAnalyticsCurrency(),
              value: roundAnalyticsMoney(calculateItemPrice({ item, quantity: basketItem.quantity, selectedChoices: basketItem.selectedChoices })),
              items: [formatBasketItemForAnalytics(basketItem)],
            },
          });
        } catch (e) { console.log('Error_sending_add_to_cart_analytics', e); }
        if (isWebConfig()) {
          this.props.closeModal();
        } else {
          forwardTo(item?.fromUpsell ? '/order-summary' : '/order', { selectedMenu: item?.selectedMenu || [], menuFilters: item?.menuFilters });
        }
      }
    }

    let allergensCodes = item.itemRichData ? (item.itemRichData.allergenCodes ? item.itemRichData.allergenCodes : []) : [];
    const modifierCodes = [...new Set(basketItem.selectedChoices.map((group) => group.map((item) => item?.itemRichData?.allergenCodes).flat()).flat())].filter(Boolean);
    if (allergensCodes.length > 0 || modifierCodes.length > 0) {
      let allergensData = [{ allergens: this.state.allergensCodes }, { sku: item.sku }];
      if (isDefined(basketItem.selectedChoices)) {
        basketItem.selectedChoices.forEach((group) => {
          group.forEach((item) => {
            if (isDefined(item.itemRichData) && isDefined(item.itemRichData.allergenCodes) && item.itemRichData.allergenCodes.length > 0) {
              setAllergen([{ allergens: item.itemRichData.allergenCodes }, { sku: item.sku }]);
            }
          });
        });
      }
      setAllergen(allergensData);
    }
  };

  setShowValidationAlert = (flag) => this.setState({ showValidationAlert: flag });

  scrollToRequiredField = () => {
    const requiredGroups = document.querySelectorAll('.group-required');
    document.querySelectorAll('.group-required').forEach((el) => el.classList.add('with-error'));

    if (!isWebConfig()) {
      document.querySelector('.item-detals-background').scrollTo({
        top: requiredGroups[0].offsetTop + 420,
        left: 0,
        behavior: 'smooth',
      });
    } else {
      document.querySelector('.item-details-content').scrollTo({
        top: requiredGroups[0].offsetTop + 60,
        left: 0,
        behavior: 'smooth',
      });
    }
  };
  getShowAddToOrderVisibilityStatus = () => {
    const availableOrderModules = getConfig().delivery.filter((d) => !d.isRemoved && !d.isDisabled && !d.isHiddenFromSidebar);
    const availableOrderModulesHiddenFromSidebar = getConfig().delivery.filter((d) => !d.isRemoved && !d.isDisabled && d.isHiddenFromSidebar);
    if (availableOrderModules.length > 0) {
      return true;
    }
    if (availableOrderModulesHiddenFromSidebar.length > 0) {
      if (isEmptyObject(Basket.getRestaurant())) {
        return false;
      } else {
        return true;
      }
    }
  };
  render() {
    const { __, profile, hideIncrementer, item } = this.props;
    const { quantity, price, showValidationAlert, allergensCodes } = this.state;
    const menuDealGroups = item.menuDealGroups ? item.menuDealGroups : [];
    const isAddToOrderBtnValid = validateItem(this.constructBasketItem()).errorCount === 0;
    const showOrderNowButton = Basket.getOrderType() === 'browse-menu' ? Basket.getRestaurant()?.show_order_now_button : true;
    let showAddToOrder = this.getShowAddToOrderVisibilityStatus(getConfig().delivery);

    return (
      <>
        <div className="item-details-card-content">
          <IonList className="item-details-card-list box-with-shadow">
            {menuDealGroups.map(this.drawMenuDealGroups)}
            {getConfig().flags.specialInstructions.isDisplayed && showOrderNowButton ? (
              <>
                {this.state.instructions === '' ? (
                  <IonButton
                    onClick={() => {
                      this.setState({ specialInstructionsModalOpen: true });
                    }}
                    color="secondary"
                    className="link no-borders add-instructions-button capitalized   transparent"
                  >
                    {__('Add special instructions')}
                  </IonButton>
                ) : (
                  <>
                    <IonItem lines="none">
                      <div tabIndex="-1"></div>
                      <Subtitle className="bold label-color special-instructions-title">{__('Special Instructions')}</Subtitle>
                    </IonItem>
                    <div
                      className="box-content special-instructions-wrapper"
                      onClick={() => {
                        this.setState({
                          specialInstructionsModalOpen: true,
                        });
                      }}
                    >
                      <NormalText>{this.state.instructions}</NormalText>


                      <EditIcon className='fill-text' style={{ margin: 0 }} onClick={() => {
                        this.setState({
                          specialInstructionsModalOpen: true,
                        });
                      }} />

                    </div>
                  </>
                )}
                <Modal
                  className='fit-content'
                  onDidDismiss={() => this.setState({ specialInstructionsModalOpen: false })}
                  showBackArrow
                  isOpen={this.state.specialInstructionsModalOpen}
                >
                  <Title className='modal-title block centered' style={{ width: '100%', lineHeight: '1' }}>{__('Special Instructions')}</Title>
                  <Spacer size={5} />
                  <IonItem class="input-field-wrapper" lines="none">
                    <IonTextarea
                      onIonInput={this.instructionsChange}
                      rows={5}
                      placeholder={__('Enter your instructions')}
                      value={this.state.modalInstructions}
                    ></IonTextarea>
                  </IonItem>
                  <Spacer size={5} />
                  <IonButton
                    color="primary"
                    expand="block"
                    className="button-uppercase"
                    onClick={() => {
                      setTimeout(() => {
                        this.setState({
                          instructions: this.state.modalInstructions,
                          specialInstructionsModalOpen: false,
                        });
                      }, 500);
                    }}
                  >
                    {' '}
                    {__('Save instructions')}
                  </IonButton>
                  <Spacer size={4} />
                  <IonButton onClick={() => this.setState({ specialInstructionsModalOpen: false })} color='secondary' expand='block' className='link'>{__('Cancel')}</IonButton>
                </Modal>
              </>
            ) : null}
          </IonList>
        </div>
        {getConfig().frenchDisclaimer?.disclaimerImage && !isWebConfig() && (
          <div style={{ padding: 'var(--ion-padding-page)' }} className="disclaimer-wrapper">
            <img className='disclaimer-image' src={getConfig().frenchDisclaimer?.disclaimerImage}></img>
          </div>
        )}
        <div className="mobile-only" style={{ height: '200px' }}></div>

        {!hideIncrementer && showOrderNowButton ? (
          <>
            {showAddToOrder && (
              <div
                style={{
                  ...(getConfig().frenchDisclaimer?.dashboardDisclaimerImage
                    ? { paddingBottom: '40px' }
                    : null),
                }}
                className="item-details-actions flex-col-wrapper flex-align-center flex-justify-between"
              >
                <Incrementer
                  allowNegative={false}
                  quantity={quantity}
                  onUpdate={this.onIncrementerUpdate}
                  minLimit={1}
                  {...(isWebConfig() && { allowInput: true })}
                />
                <IonButton
                  disabled={quantity < 1}
                  className={
                    'button-uppercase item-details-add-to-order break-spaces ' +
                    (isAddToOrderBtnValid ? '' : 'disabled')
                  }
                  size="full"
                  expand='block'
                  shape="round"
                  onClick={!isAddToOrderBtnValid ? this.scrollToRequiredField : this.addToOrder}
                >
                  <NormalText>{(Basket.getOrderType() === 'browse-menu') || (Basket.itemsCount() === 0 && isEmptyObject(this.props.ikentooMenu))
                    ? __('Start New Order')
                    : __('Add to Order')}</NormalText>
                  <NormalText>{price}</NormalText>
                </IonButton>

              </div>
            )}
          </>
        ) : null}
        <IonAlert
          isOpen={showValidationAlert}
          onDidDismiss={() => this.setShowValidationAlert(false)}
          header={__('Validation')}
          message={__('Please check any required options')}
          buttons={[{ text: __('OK'), role: 'cancel', cssClass: 'secondary' }]}
        />
      </>
    );
  }
}

const mapStateToProps = (store) => {
  return {
    profile: store.profile.profile,
    restaurantsUpdated: store.restaurants.restaurantsUpdated,
    basketUpdated: store.orders.basketUpdated,
    allergens: store.restaurants.allergens,
    storedItemWeb: store.orders.storedItemWeb,
    ikentooMenu: store.restaurants.ikentooMenu || {},
    clientProfile: store.common.clientProfile,

  };
};

export const ItemDetailsRaw = connect(mapStateToProps)(withTranslation(itemDetailsContent));

class itemDetails extends Component {
  constructor(props) {
    super(props);
    this.x = React.createRef();
    this.state = {
      nameVisible: true,
      allergens: []
    };
  }
  onContentScrollHandler() {
    if (!this.isScrolledIntoView(this.x.current)) {
      this.setState({ nameVisible: false });
    } else {
      this.setState({ nameVisible: true });
    }
  }
  isScrolledIntoView(el) {
    var rect = el.getBoundingClientRect();
    var elemTop = rect.top;
    var elemBottom = rect.bottom;
    var isVisible = elemTop >= 0 && elemBottom <= window.innerHeight;
    return isVisible;
  }
  shouldComponentUpdate(prevProps, prevState) {
    if (this.state.nameVisible !== prevState.nameVisible || this.state.allergens !== prevState.allergens) {
      return true;
    } else {
      return false;
    }
  }
  handleAlergens = (allergens) => {
    this.setState({ allergens })
  }
  render() {
    const { location, __, profile } = this.props;
    const item = location.state;
    const { selectedMenu } = item;
    const { allergens } = this.state
    const hasNutritionInfo = getConfig().flags.hasNutritionTab || item?.itemRichData?.calories || item?.itemRichData?.dietaryFlags?.length > 0 || (getConfig().flags.hasItemIngredients && item?.itemRichData?.ingredients?.length > 0)
    let image =
      item.itemRichData && item.itemRichData.squareImageUrl ? item.itemRichData.squareImageUrl : '';
    if (image && image.indexOf('http://') !== -1) {
      image = image.replace(/http:\/\//g, 'https://');
    }
    return (
      <Layout
        headerTitle={__('Item Details')}
        scrollY={false}
        color="transparent"
        noPadding
      >
        <div className="item-details-main-wrapper">
          <div
            className={
              this.state.nameVisible ? ' item-details-header' : 'active item-details-header'
            }
          >
            <div className="item-details-back">
              <IonButton
                className="solo-button"
                color="white"
                onClick={() => forwardTo(item?.fromUpsell ? '/order-summary' : item?.fromDashboard ? '/dashboard' : '/order', { selectedMenu, menuFilters: item?.menuFilters })}
              >
                <IonIcon slot="icon-only" icon={chevronBackOutline} />
              </IonButton>
            </div>
            <div
              style={{
                transition: !this.state.nameVisible ? 'transform 0.3s ease-in-out' : 'none',
                display: 'flex',
                alignItems: 'center',
                marginLeft: '20px',
                transform: this.state.nameVisible ? 'translateY(-300px)' : 'translateY(0)',
              }}
            >
              <Title>
                {__(getProductName(item, profile))}
              </Title>
            </div>
          </div>
          <div
            className="scrollable-y item-detals-background"
            onScroll={() => {
              this.onContentScrollHandler();
            }}
          >
            <div className="item-details-info">
              {!getConfig().flags.removeMenuImages &&
                <>
                  {image && image !== '' ? (
                    <div className="item-details-img">
                      <img alt="item details" src={image} />
                    </div>
                  ) : (
                    <div className="item-details-img">
                      <img style={{ objectFit: 'contain' }} alt="item details" src={Basket.getRestaurant()?.menu_item_placeholder_image ?? this.props.clientProfile.logo_image} />
                    </div>
                  )}
                </>
              }
              <div className="item-details-name" ref={this.x}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 'var(--spacer-2)' }}>
                  <Title>{__(getProductName(item, profile))}</Title>
                  {(!getConfig()?.stamp_earning_skus?.includes(item.sku) && parseFloat(item.productPrice) > 0) &&
                    <Title>{formatPrice(item.productPrice)}</Title>
                  }
                </div>
                {getProductDescription(item, profile) !== '' &&
                  <>
                    <Spacer size={2} />
                    <NormalText
                      className="item-details-card-description"
                      dangerouslySetInnerHTML={{
                        __html: getConfig().flags.removeHTMLTagsOnProductDescription ? getProductDescription(item, profile) : getProductDescription(item, profile).replace(/(<([^>]+)>)/gi, ''),
                      }}
                    ></NormalText>                </>
                }
                {allergens.length > 0 && !hasNutritionInfo ? (
                  <>
                    <Spacer size={2} />
                    <SmallText className='primary-color'>
                      {allergens.map(el => __(capitalize(el))).join(', ')}
                    </SmallText>
                  </>
                ) : null}
                {hasNutritionInfo &&
                  <>
                    <Spacer size={2} />
                    <div style={{ display: 'grid', gap: 'var(--spacer-2)' }}>
                      {allergens.length > 0 ? (
                        <div>
                          <StrongText>{__('Allergens')}</StrongText>
                          <SmallText className='primary-color'>
                            {allergens.map(el => __(capitalize(el))).join(', ')}
                          </SmallText>

                        </div>
                      ) : null}

                      {item.itemRichData?.dietaryFlags?.length > 0 ? (
                        <div>

                          <StrongText>{__('Dietary flags')}</StrongText>
                          <SmallText className='primary-color'>
                            {item.itemRichData?.dietaryFlags.map(el => __(capitalize(el.standard_name.toLowerCase().replace(/_/g, ' ')))).join(', ')}
                          </SmallText>

                        </div>
                      ) : null}
                      {item.itemRichData?.ingredients?.length > 0 && getConfig().flags.hasItemIngredients ? (
                        <div>

                          <StrongText>{__('Ingredients')}</StrongText>
                          <SmallText className='primary-color'>
                            {item.itemRichData?.ingredients.map(el => __(capitalize(el.standard_name.toLowerCase().replace(/_/g, ' ')))).join(', ')}
                          </SmallText>
                        </div>
                      ) : null}
                      {item.itemRichData?.calories ? (
                        <div>
                          <StrongText>{__('Calories')}</StrongText>
                          <SmallText className='primary-color'>
                            {`${item.itemRichData?.calories} ${__('kcal')}`}
                          </SmallText>
                        </div>
                      ) : null}
                    </div>
                  </>

                }

                {getConfig()?.customExternalLinks?.product &&
                  <>

                    <Spacer size={2} />
                    <IonButton
                      onClick={() => {
                        openExternalLink(getConfig().customExternalLinks.product?.url)
                      }}
                      color="secondary"
                      className=" link no-borders add-instructions-button capitalized   transparent"
                    >
                      {__(getConfig().customExternalLinks.product?.title)}
                    </IonButton>
                    <Spacer />
                  </>
                }
              </div>
              {getConfig()?.stamp_earning_skus?.includes(item.sku) &&
                <>
                  <Spacer size={4} />
                  <div style={{ padding: '0 var(--ion-padding) 0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div className='product-has-stamp-earned'>
                      {getConfig()?.stamp_earning_skus?.includes(item.sku) &&
                        <>
                          <DiscountIcon />
                          <SmallText>{__('Earns loyalty stamps')}</SmallText>
                        </>
                      }
                    </div>
                    <div className="item-details-price">
                      <Subtitle>{formatPrice(item.productPrice)}</Subtitle>
                    </div>
                  </div>
                </>
              }
            </div>
            <Spacer size={5} />
            <ItemDetailsRaw handleAlergens={this.handleAlergens} item={item} profile={profile} />
          </div>
        </div>
      </Layout>
    );
  }
}

const stateToProps = (store) => {
  return {
    profile: store.profile.profile,
    clientProfile: store.common.clientProfile,
  };
};

export default connect(stateToProps)(withTranslation(itemDetails));
